import React, { Component } from "react";
import Bio from "./sections/Bio";
import Research from "./sections/Research";
import Contact from "./sections/Contact";
import photo from "./internalAsset/Daniel_CMU_Board.jpeg"

class App extends Component {
  render() {
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div className="container" style={{ marginTop: '1rem' }}>
          <div style={{ marginBottom: '5px' }}>
            <h1 style={{ marginBottom: '0', marginTop: '0', paddingBottom: '0', lineHeight: '1' }}>Daniel A. Herrmann</h1>
          </div>
          <div>
            <img className="logo" src={photo} title="ΣΣ" alt='ΣΣ' style={{ width: '100%', height: 'auto', marginTop: '0', paddingTop: '0' }} />
          </div>
          <div className="row headline" style={{ marginTop: '1rem' }}>
            <div className="nine columns">
              <h1 style={{ marginBottom: '1rem', marginTop: '0' }}>
                I am a decision theorist, formal epistemologist, and philosopher of AI. I am currently an Assistant Professor of Philosophy at <a href="https://philosophy.unc.edu/">UNC Chapel Hill</a>, and Core Faculty for the <a href="https://ppe.unc.edu/">UNC PPE Program</a>.          
                <br /><br />
               
              </h1>
            </div>
          </div>
          <div className="row" style={{ marginTop: '1rem', marginBottom: '1rem' }}>
            <hr />
          </div>
          <Bio />
          <div className="row" style={{ marginTop: '2rem', marginBottom: '1rem' }}>
            <hr />
          </div>
          <Research />
          <div className="row" style={{ marginTop: '2rem', marginBottom: '1rem' }}>
            <hr />
          </div>
          <Contact />
        </div>
      </div>
    );
  }
}

export default App;
